import * as ActionTypes from '../constants/ActionTypes';
import API from '../helpers/api';

export function verifyEmail(t) {
	return async dispatch => {
		dispatch({
			type: ActionTypes.VERIFY_EMAIL_REQUEST,
			payload: { loadingVerify: true }
		});

		const response = await API.user.verifyUserEmail(t);

		if(response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.VERIFY_EMAIL_ERROR,
				payload: {
					meta: response.meta,
					loadingVerify: false
				}
			});
		}
		const { user } = response.data;

		dispatch({
			type: ActionTypes.VERIFY_EMAIL_SUCCESS,
			payload: {
				user,
				loadingVerify: false,
				meta: response.meta
			}
		});
	};

}

export function resetPage() {
	return async dispatch => {
		dispatch({
			type: ActionTypes.RESET_VERIFY_EMAIL_PAGE
		});
	};
}

export function resetMeta() {
	return async dispatch => {
		dispatch({
			type: ActionTypes.RESET_VERIFY_EMAIL_META
		});
	};
}
